import "react-router-modal/css/react-router-modal.css";

import React from "react";
import { Route, Switch } from "react-router-dom";
import { ModalRoute } from "react-router-modal";

import Landing from "../../base/containers/Landing";
import GroupsContainer from "../../groups/containers/Groups";
import ListView from "../../listview/containers/ListView";
import Logs from "../../logs/containers/Logs";
import AddService from "../../policies/containers/AddService";
import AddUserGroupContainer from "../../policies/containers/AddUserGroup";
import NoServices from "../../policies/containers/NoServices";
import Policies from "../../policies/containers/Policies";
import Role from "../../roles/containers/Roles";
import ScopesContainer from "../../scopes/containers/Scopes";
import Services from "../../services/containers/Services";
import Settings from "../../settings/containers/Settings";
import AuthenticatedRoute from "../containers/AuthenticatedRoute";

const Routes = () => (
  <>
    <Route exact path="/" component={Landing} />
    <AuthenticatedRoute path="/policies" component={Policies} />
    <Switch>
      <ModalRoute
        component={AddService}
        exact
        path="/(policies|listview)/services/add"
        parentPath="/policies"
      />
      <ModalRoute
        component={Services}
        path="/(policies|listview)/services/:name?"
        parentPath="/policies"
      />
      <ModalRoute
        component={ScopesContainer}
        path="/(policies|listview)/scopes/:name?"
        parentPath="/policies"
      />
      <ModalRoute
        component={Role}
        path="/(policies|listview|settings)/roles/:name?"
        parentPath="/policies"
      />
      <ModalRoute
        component={AddUserGroupContainer}
        exact
        path="/(policies|listview)/groups/add"
        parentPath="/policies"
      />
      <ModalRoute
        component={GroupsContainer}
        path="/(policies|listview|settings)/groups/:name?"
        parentPath="/policies"
      />
    </Switch>
    <ModalRoute
      component={NoServices}
      exact
      path="/noservices"
      parentPath="/policies"
    />
    <AuthenticatedRoute exact path="/listview" component={ListView} />
    <AuthenticatedRoute exact path="/logs" component={Logs} />
    <AuthenticatedRoute exact path="/settings" component={Settings} />
  </>
);

export default Routes;
